module.exports = __webpack_public_path__ + "img/vi.722884c9.svg";